import React from 'react';
import { FormDialog } from '../../../form-dialog';
import { Box } from '../../../box';
import { Row } from '../../../row';
import { Cell } from '../../../cell';
import { UserLookup, TeamLookup } from '../../../lookups';
import { FormControl } from '../../../form-control/form-control';
import { Container } from '../../../container/container';

export interface IAssignCasesCaseworkerDialogComponentProps {
  teamId?: string;
  userId?: string;
  isLoading?: boolean;
  onTeamChange: (team: string | undefined) => void;
  onUserChange: (userId: string | undefined) => void;
  isOpen: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function AssignCasesCaseworkerDialogComponent({
  teamId,
  userId,
  onTeamChange,
  onUserChange,
  isOpen,
  onConfirm,
  onClose,
  isLoading,
}: IAssignCasesCaseworkerDialogComponentProps) {
  return (
    <FormDialog
      open={isOpen}
      title="Tildel ansvarlig sagsbehandler"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isLoading}
      onConfirmClick={onConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid
    >
      <FormControl fullWidth>
        <Container>
          <Box width="1000px">
            <Row>
              <Cell size="full">
                <UserLookup value={userId} onChange={onUserChange} />
              </Cell>
              <Cell size="full">
                <TeamLookup required value={teamId} onChange={onTeamChange} disableClearable />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
